import React, {useState} from "react";
import Button from "reactstrap/lib/Button";
import Modal from "reactstrap/lib/Modal";
import ModalBody from "reactstrap/lib/ModalBody";
import ModalHeader from "reactstrap/lib/ModalHeader";
import {t} from "react-switch-lang";
import DeactivateImg from '../customTable/img/deactivate.svg';
import './Modals.css';
import Exclusion from "./img/Exclusion 2.svg";
import DeactivateDepartment from '../../app/administration/department/components/DeactivateDepartment';

export function Deactivate(props) {
    const [modal, setModal] = useState(false);
    const departmentModal = () => setModal(!modal);

    var buttonText = "";
    if (props?.data?.active === true) {
        buttonText = t("buttons.deactivateBtn");
    } else {
        buttonText = t("buttons.activateBtn");
    }

    return (
        <>
            <Button className="danger modal-open-button"
                    onClick={departmentModal}>
                <img src={DeactivateImg} alt=""/>
              <span>{buttonText}</span>
            </Button>
            <Modal
                isOpen={modal}
                toggle={departmentModal}
                className="modal-md modalDelete"
                backdrop="static">
                <ModalHeader toggle={departmentModal}>
                    <div> {buttonText} {t('departments.departmentHeader')}</div>
                    <img src={Exclusion} alt="Exclusion"
                         onClick={departmentModal} style={{cursor: "pointer"}}/>
                </ModalHeader>
                <ModalBody className="d-flex flex-row">
                    <div>
                        <div className="row">
                            <div className="py-2 my-2">
                              <h3>{`${
                                props?.data?.active
                                  ? t("question.deactivate")
                                  : t("question.activate")
                              } ${props?.data?.name}  ?`}</h3>
                            </div>
                            <div
                                className="container-fluid decorationLine"></div>
                            <div className="text-righ offset-5">
                                <Button onClick={departmentModal}
                                        className="danger cancelButton">
                                    {t('buttons.cancelBtn')}
                                </Button>
                            </div>
                            <div className="text-righ">
                                <div className="text-right">
                                    <DeactivateDepartment
                                        data={props?.data}
                                        activated={props?.data?.active}
                                        toggleModal={() => setModal(false)}
                                        setRowChanged={() => props.setRowChanged()}/>
                                </div>
                            </div>

                        </div>
                    </div>
                </ModalBody>
            </Modal>
        </>
    );
}
